import { motion } from "framer-motion";
import { Box } from "@suit-ui/react";

const MotionBox = motion(Box);

export default MotionBox;
